import { FC } from "react";

import { Priority } from "../models/priority-model";

import { PriorityView } from "./priority-view";
import { PriorityViewEmpty } from "./priority-view-empty";

interface PriorityViewOptionalProps {
  priority?: Priority | null;
  logoOnly?: boolean;
  canTruncateLabel?: boolean;
  className?: string;
}

export const PriorityViewOptional: FC<PriorityViewOptionalProps> = ({ priority, ...props }) => {
  if (!priority) {
    return <PriorityViewEmpty {...props} />;
  }

  return <PriorityView priority={priority} {...props} />;
};
